import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as ngswal from "sweetalert";
import { ApiMethod } from '../../apimethods/api-method';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants';
import { Proofing_MailBodyAPIModel } from './proofing-mailbody';
declare var $;
@Component({
  selector: 'app-proofing-mailbody',
  templateUrl: './proofing-mailbody.component.html',
  styleUrls: ['./proofing-mailbody.component.css']
})
/** Proofing-MailBody component*/
export class ProofingMailBodyComponent {
  modelItem = new Proofing_MailBodyAPIModel();
  //table fields
  @ViewChild('dataTable', { static: false }) table: { nativeElement: any; }
  dataSet: string;
  dataTable: any;
  showModal: boolean = false;
  JournalList: any;
  ProofingType: any;
  ArticleStageList: any;
  ProofingStageList: any;
  title: string;
  popUpButtonText: string;

  ngOnInit(): void {
    ApiMethod.getBaseUrl();
    $('#Txt_MailBody').jqte();
  }
  /** Proofing-MailBody ctor */
  constructor(private router: Router, private route: ActivatedRoute) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <Proofing_MailBodyAPIModel>data["ProofingMailBodyPage"];

        this.GetJournal();
        this.GetArticleStage();
        this.GetProofingStage();
        this.GetProofingType();
        this.MainGridTable();


        $('#ddlProofingType').select2({
          placeholder: "Select Proofing Type",
          dropdownParent: "#popupbody"
        });
        $('#ddlPublisherId').select2({
          placeholder: "Select Publisher",
          /*  allowClear: true, tags: true,*/
          dropdownParent: "#popupbody"
        });
        $('#ddlJournalId').select2({
          placeholder: "Select JournalId",
          /*  allowClear: true, tags: true,*/
          dropdownParent: "#popupbody"
        });
        $('#ddlArticleStage').select2({
          placeholder: "Select Article Stage",
          /*  allowClear: true, tags: true,*/
          dropdownParent: "#popupbody"
        });
        $('#ddlProofingStage').select2({
          placeholder: "Select Proofing Stage",
          /*  allowClear: true, tags: true,*/
          dropdownParent: "#popupbody"
        });
        $('#ddlJournalMode').select2({
          placeholder: "Select Journal Mode",
          /*  allowClear: true, tags: true,*/
          dropdownParent: "#popupbody"
        });
      });
    error => {
      ngswal("Warning !", error.message, "warning");
    };
  }


  //Get JournalName
  GetJournal(): void {
    ApiMethod.getMethod(this.modelItem.GetJournal).subscribe(
      result => {
        this.JournalList = result.aJournal;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //GetProofingType
  GetProofingType(): void {
    ApiMethod.getMethod(this.modelItem.GetProofingType).subscribe(
      result => {
        this.ProofingType = result.aProofingType;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //GetArticleStage
  GetArticleStage(): void {
    ApiMethod.getMethod(this.modelItem.GetArticleStage).subscribe(
      result => {
        this.ArticleStageList = result.aArticleStage;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //GetProofingStage
  GetProofingStage(): void {
    ApiMethod.getMethod(this.modelItem.GetProofingStage).subscribe(
      result => {
        this.ProofingStageList = result.aProofingStages;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }


  //MailBody MainTable 
  MainGridTable() {
    $("LoadingImage").show();

    var dataItem = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      ModuleName: "proofingmailbody"
    }
    ApiMethod.postMethod(this.modelItem.ProofingMailBodyTableGridAPI, dataItem).subscribe(
      Response => {
        console.log(Response.aMailbodyList);
        console.log(Response.agridColumnList);
        this.dataSet = JSON.stringify(Response.aMailbodyList); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);
        //Dynamic datable
        let aColList = Response.agridColumnList; // grid column data
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 250);
        dataItem.modulename = 'proofingmailbody';
        dataItem.aNewButtonName = 'BtnPopup';
        dataItem.isDefault = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  Show() {
    $("LoadingImagePopup").show();
    this.ClearData();

    $('#Divmail .jqte_editor').css({ 'height': (GlobalConstants.size.height - 300), 'resize': 'none' });  //jqte
    $('#btnPopupartDetails').show();
    //show proofing mailboday data by Id 
    if (localStorage.aEID != 0) {
      var aResult = {
        Id: localStorage.aEID,
        PublisherID: localStorage.aPubID
      };
      ApiMethod.postMethod(this.modelItem.GetMailBodybyid, aResult).subscribe(
        Response => {
         
          let aitems = Response.aResult;

          $("#ddlProofingType").val(aitems[0].ProofingType).change();
          $("#ddlJournalMode").val(aitems[0].JournalMode).change();
          $("#ddlJournalId").val(aitems[0].JournalId).change();
          $("#ddlArticleStage").val(aitems[0].ArticleStageId).change();
          $("#ddlProofingStage").val(aitems[0].ProofingStageId).change();
          $('#Txt_SammpleFileName').val(aitems[0].SampleFileName);
          $('#Txt_MailBody').val(aitems[0].MailBody);
          $('#Txt_IsReminder').prop("checked", aitems[0].IsReminder);
          $('#Txt_ReminderNo').prop("checked", aitems[0].ReminderNo);
          $('#Txt_IsConfirmation').prop("checked", aitems[0].IsConfirmation);

          $('#Divmail .jqte_editor').html(aitems[0].MailBody);//Jqte editor


          if (aitems[0].IsReminder == 1) {
            $('#Txt_IsReminder').prop('checked', true);
          } else {
            $('#Txt_IsReminder').prop('checked', false);
          }
          if (aitems[0].ReminderNo == 1) {
            $('#Txt_ReminderNo').prop('checked', true);
          } else {
            $('#Txt_ReminderNo').prop('checked', false);
          }
          if (aitems[0].IsConfirmation == 1) {
            $('#Txt_IsConfirmation').prop('checked', true);
          } else {
            $('#Txt_IsConfirmation').prop('checked', false);
          }


          this.title = "Proofing-MailBody";
          this.popUpButtonText = "Update";
        },
        error => {
          $("#LoadingImagePopup").hide();
          ngswal("Failed !", error.message, "error");
        });
      $("#LoadingImagePopup").hide();
    } else {
      //show popup

      this.showModal = true;
      this.popUpButtonText = "Add";
      this.title = " Add Proofing-MailBody ";
      $("LoadingImagePopup").hide();
    }
  }

  UpdateTemplateData(): void {

    //Validation 
    if ($('#Txt_SammpleFileName').val().trim() == '') {
      ngswal("Warning !", "Enter Sample FileName !", "warning");
    }
   else if ($('#Txt_MailBody').val() == '') {
      ngswal("Warning !", "Enter Mailbody!", "warning");
    } 
    
    else if ($('#ddlProofingType').val() == null) {
      ngswal("Warning !", "Select Proofing Type!", "warning");
    }
    
    else if ($('#ddlJournalId').val() == null) {
      ngswal("Warning !", "Select Journal!", "warning");
    }
    
    else {
      //Getting Updated value
      $("#LoadingImagePopup").show();
      var IsConfirmation = $('#Txt_IsConfirmation').prop('checked');
      if (IsConfirmation == true) {
        IsConfirmation = 1;
      } else {
        IsConfirmation = 0;
      }
      var IsReminder = $('#Txt_IsReminder').prop('checked');
      if (IsReminder == true) {
        IsReminder = 1;
      } else {
        IsReminder = 0;
      }
      var ReminderNo = $('#Txt_ReminderNo').prop('checked');
      if (ReminderNo == true) {
        ReminderNo = 1;
      } else {
        ReminderNo = 0;
      }
      var dataparam = {

        Id: localStorage.aEID,
        PublisherId: localStorage.aPubID,
        ProofingType: $('#ddlProofingType').val(),
        JournalId: $('#ddlJournalId').val(),
        ArticleStageId: $('#ddlArticleStage').val(),
        ProofingStageId: $('#ddlProofingStage').val(),
        JournalMode: $('#ddlJournalMode').val(),
        SampleFileName: $('#Txt_SammpleFileName').val(),
        Mailbody: $('#Txt_MailBody').val(),
        IsReminder: IsReminder,
        ReminderNo: ReminderNo,
        IsConfirmation: IsConfirmation,

      };


      ApiMethod.postMethod(this.modelItem.updateMailBodyData, dataparam).subscribe(
        response => {
          this.MainGridTable();
          $("#LoadingImagePopup").hide();
          this.hide();

          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: response.aResultL,
            showConfirmButton: true,

          });

        },
        error => {
          ngswal("Failed !", error.error.Message, "warning");
          $("#LoadingImagePopup").hide();
        }
      );
    }
  }

  hide() {
    this.ClearData();
    $('#btnPopupartDetails').hide();
    localStorage.aEID = "";
  }

  ClearData(): void {
    $('#Txt_MailBody').val('');
    $('#Divmail .jqte_editor').html('');   //jqte
    $('#Txt_SammpleFileName').val('');
    $("#ddlProofingType").val(0).change();
    $("#ddlJournalId").val(0).change();
    $("#ddlJournalMode").val(0).change();
    $("#ddlArticleStage").val(0).change();
    $("#ddlProofingStage").val(0).change();
    $('#Txt_IsReminder').prop('checked', false);
    $('#Txt_ReminderNo').prop('checked', false);
    $("#Txt_IsConfirmation").prop('checked', false);
  }

}

